import { render, staticRenderFns } from "./AppUpdate.vue?vue&type=template&id=4d51fa1f&scoped=true"
import script from "./AppUpdate.vue?vue&type=script&lang=js"
export * from "./AppUpdate.vue?vue&type=script&lang=js"
import style0 from "./AppUpdate.vue?vue&type=style&index=0&id=4d51fa1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d51fa1f",
  null
  
)

export default component.exports